import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { Box } from "@mui/material";
import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";
import pattern from "@src/images/igLogo/pattern-logo.png";

import { setDialog } from "../../store/slices/global";

export const NotSubscribedRoute = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(
      () =>
        dispatch(
          setDialog({
            dialog: "onboarding",
            open: true,
            props: { noClose: true, hideBackdrop: true },
          })
        ),
      500
    );
  }, []);

  return (
    <>
      <NavigationDrawer isUnauthorized={true} />
      <Box
        className={"pattern-background"}
        sx={{
          margin: "-8px",
          height: "100vh",
          opacity: ".65",
          width: "100vw",
          backgroundImage: `url(${pattern})`,
        }}
      ></Box>
    </>
  );
};
